<template>
    <div class="page-wrapper book-wrapper" ref="books">
        <!-- 背景颜色 新版目前注释 -->
        <!-- <div class="page-absolute page-background">
            <div class="top"></div>
            <div class="bottom"></div>
        </div> -->

        <!-- 搜索框 -->
        <div class="movie-wrapper header acea-row row-center-wrapper"
            :class="{ 'page-fixed fixed-search': fixedSearch }">
            <router-link :to="'/bookSearch'" class="search acea-row row-middle">
                <div class="search-icon-img"></div>搜索书名或作者
            </router-link>
        </div>

        <!-- 轮播图 -->
        <div class="movie-wrapper page-margin-top2 swiper-box" :class="{ 'marginTop': fixedSearch }">
            <Swiper :swiperImgStyle="swiperImgStyle" :swiperStyle="swiperStyle" @goToUrl="goSwiperUrl"
                :imgOption="imgOption" :data="swiperData"></Swiper>
        </div>

        <!-- 分类卡片 -->
        <div class="nav acea-row" v-if="bookIconCategory.length > 0">
            <router-link :to="{
    path: '/goods_list',
    query: { id: item.id, title: item.cate_name, hierarchy: true, type: 2, Switch: true }
}" class="item" v-for="(item, index) in bookIconCategory" :key="index">
                <div class="pictrue"><img v-lazy="item.pic" alt="img" /></div>
                <div>{{ item.cate_name }}</div>
            </router-link>
            <router-link :to="{
    path: '/bookCategory'
}" class='item'>
                <div class="pictrue"><img src="@assets/images/index-all.png" alt="img" /></div>
                <div>全部分类</div>
            </router-link>
        </div>

        <!-- 新书上架 -->
        <!-- <div class="newBookshelf">
            <div class="newBook_title">
                <div class="title_text">新书上架</div>
                <div class="title_more">查看更多 ></div>
            </div>
  
            <div class="newBook_content">
                <div class="content">
                    <div class="content_image">
                        <img src="../../assets/images/newbook_shili.png" alt="">
                    </div>
                    <div class="content_text">
                        <div>天才在左疯子在右在右...</div>
                        <div class="content_name">高铭</div>
                        <div class="content_money">
                            <div class="money_number">500.00
                                <img src="../../assets/images/shuji_icon_jindou.png" alt="">
                            </div>
                            <div class="money_plus">+</div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <div class="content_image">
                        <img src="../../assets/images/newbook_shili.png" alt="">
                    </div>
                    <div class="content_text">
                        <div>天才在左疯子在右在右...</div>
                        <div class="content_name">高铭</div>
                        <div class="content_money">
                            <div class="money_number">500.00
                                <img src="../../assets/images/shuji_icon_jindou.png" alt="">
                            </div>
                            <div class="money_plus">+</div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->


        <!-- 模块循环 标题+数据 -->
        <div class="movie-box page-margin-top3">
            <div class="movie-box" v-for="(item, ind) in bookList" :key="ind">
                <div
                    class="movie-wrapper acea-row row-between row-bottom page-background-color-white page-margin-bottom2 book-model-title-wrapper">
                    <span class="book-model-title">{{ item.category }}</span>
                    <span class="color-text more" @click="gotoType(item.id, item.category)">更多</span>
                </div>
                <div class="movie-box page-background-color-white book-list-wrap">
                    <bookGoodList :textTitleStyle="textTitleStyle" :wrapStyle="wrapStyle" :imageStyle="imageStyle"
                        :boxStyle="boxStyle" :goodList="item.list" :bottomBoxStyle="bottomBoxStyle" :isSort="false"
                        :isShowSale="false" :isShowShopCart="false" :isPrice="true" :isAuthor="false"></bookGoodList>
                </div>
            </div>
        </div>

        <!-- 图书分类导航 -->
        <div class="movie-wrapper page-background-color-white" :class="{ 'page-fixed fixed-paginationshop': fixedNav }">
            <div class="movie-horizontal-scroll-bar paginationshop" ref="bookNavBar">
                <div v-for="(item, ind) in shopNavList" :key="ind" class="paginationslot"
                    :class="{ activeNav: currentShopNav === ind }" :ref="'bookNav' + ind"
                    @click="changeCurrentShopNav(ind, item)">{{ item.cate_name }}</div>
            </div>
        </div>
        <!-- swiper -->
        <div class="wrapper sort-shop-swiper" :class="{ 'top-margin': fixedNav }">
            <div class="movie-box">
                <swiper :options="shopOption" ref="mySwiper">
                    <swiper-slide v-for="(val, index) in shopNavList" :key="index">
                        <div class="shop-page">
                            <!-- <bookGoodList v-if="currentShopNav === index" :good-list="shopDataList"
                                :boxStyle="swiperBoxStyle" :bottomBoxStyle="bottomBoxStyle" 
                                :isShowSale="false" :isShowShopCart="false" :isPrice="false" :isAuthor="true">
                            </bookGoodList> -->
                            <GoodList v-if="currentShopNav === index" :isShowSale="false" :good-list="shopDataList" :isPrice="false" :isAuthor="true" :isShowShopCart="false" :isSort="false"></GoodList>
                        </div>
                    </swiper-slide>
                </swiper>
                <div v-if="loaded" class="page-text-center over-tip">已加载完成</div>
            </div>
        </div>
        <Loading :loaded="loaded" :loading="loading"></Loading>


        <!-- 回首页 -->
        <router-link to="/">
            <div class="page-fixed back-index" title="回首页">
                <i class="iconfont icon-shouye-xianxing"></i>
            </div>
        </router-link>
    </div>
</template>

<script>
import bookGoodList from "@components/bookGoodList";
import GoodList from "@components/GoodList.vue";
import Swiper from "@components/Swiper.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import Loading from "@components/Loading";
import { getBookHomeData } from "@api/book";
import { debounceFn } from "@utils/movie.js";

//
import { getProducts } from "@api/store";
//

export default {
    name: "Book",
    components: {
        Swiper,
        bookGoodList,
        Loading,
        swiper,
        swiperSlide,
        GoodList
    },
    data: function () {
        return {
            leaveScroll: null,//离开记录滚动条的位置
            scrollbar: null, //目前滚动条的位置
            fixedSearch: false,//搜索框固定
            fixedNav: false, //导航固定
            swiperStyle: {
                "border-radius": ".25rem"
            },
            swiperImgStyle: {
                "border-radius": ".25rem"
            },
            imgOption: {
                autoplay: true,
                loop: true
            },
            shopNavList: [
                // {
                //     cate_name: "文艺",
                //     id: 57
                // }, {
                //     cate_name: "童书",
                //     id: 68
                // }, {
                //     cate_name: "历史",
                //     id: 76
                // }
            ],
            //
            currentShopNav: 0,//当前选中导航 下标
            shopOption: {
                autoplay: false,
                loop: false,
                observer: true,
                observeParents: true,
                speed: 800,
                on: {
                    slideChange: () => {
                        if (this.currentShopNav === this.swiper.activeIndex) return;
                        this.changeType(this.swiper.activeIndex);
                    }
                }
            },
            domBook: null,
            page: 1,
            limit: 20,
            loaded: false,
            loading: false,
            shopType: null,
            delay: true,
            //
            shopDataList: [],
            boxStyle: {
                "width": "2rem",
                "height": "3rem",
                "margin-left": "0",
                "margin-right": "0.1rem",
                "flex-shrink": "0",
                "float": "none",
                "vertical-align": "bottom",
                "border-radius": "0",
                "margin-bottom": "0",
                "border-radius": "0.2rem",
                "box-shadow": "0 0 0 0"
            },
            swiperBoxStyle: {
                "height": "3.8rem",
                "border-radius": "0.2rem"
            },
            wrapStyle: {
                "width": "100%",
                "padding": ".2rem 0",
                "display": "flex",
                "flex-wrap": "nowrap",
                "box-sizing": "border-box",
                "overflow-y": "hidden",
                "overflow-x": "scroll",
                "white-space": "nowrap"
            },
            bottomBoxStyle: {
                "padding-bottom": "0"
            },
            imageStyle: {
                "width": "90%",
                "height": "2.2rem",
                "max-height": "2.3rem"
            },
            textTitleStyle: {
                "line-clamp": 1
            },
            swiperData: [
                // {
                //     "pic": "http://img62.ddimg.cn/upload_img/00865/202105/750x315_wzh_20210517-1621238066.jpg",
                //     "wap_url": "/goods_list",
                //     "id": "0",
                //     "title": "最受欢迎"
                // }, {
                //     "pic": "http://img60.ddimg.cn/upload_img/00865/202105/750x315-1621238732.jpg",
                //     "wap_url": "/goods_list",
                //     "id": "1",
                //     "title": "最受欢迎"
                // }
            ],
            bookList: [
                // {
                //     category: "最受欢迎",
                //     id: 0,
                //     list: [
                //         {
                //             id: 111,
                //             image: "http://img3m2.ddimg.cn/0/27/28473192-1_l_6.jpg",
                //             store_name: "你当像鸟飞往你的山",
                //             author: "小明",
                //             price: "￥110.0"
                //         },{
                //             id: 111,
                //             image: "http://img3m2.ddimg.cn/0/27/28473192-1_l_6.jpg",
                //             store_name: "你当像鸟飞往你的山",
                //             price: "￥110.0",
                //             author: "小才不爱倒计时"
                //         }, {
                //             id: 112,
                //             image: "http://img3m6.ddimg.cn/63/10/29207736-1_l_27.jpg",
                //             store_name: "山海经（全译彩绘图说典藏版）附赠西洋古董《谟区查抄本彩绘山海经图》",
                //             price: "￥120.0",
                //             author: "小才不爱"
                //         }, {
                //             id: 113,
                //             image: "http://img3m2.ddimg.cn/14/2/28509242-1_l_11.jpg",
                //             store_name: "古代人的日常生活",
                //             price: "￥130.0",
                //             author: "小才不爱倒计"
                //         }
                //     ]
                // }, {
                //     category: "新书上架",
                //     id: 1,
                //     list: [
                //         {
                //             id: 111,
                //             image: "http://img3m6.ddimg.cn/27/14/28530936-1_l_46.jpg",
                //             store_name: "地图上的全景世界史",
                //             price: "￥210.0"
                //         }, {
                //             id: 112,
                //             image: "http://img3m8.ddimg.cn/97/30/28991158-1_l_15.jpg",
                //             store_name: "国际安徒生奖曹文轩拼音精选集（共八册，含小河弯弯，红葫芦，愤怒的哇哇，月光下的秘密，哑牛，狂奔的鸭群，八哥，有个丫头叫草环）",
                //             price: "￥50.0"
                //         }
                //     ]
                // }, {
                //     category: "新书上架1",
                //     id: 2,
                //     list: [
                //         {
                //             id: 111,
                //             image: "http://img3m6.ddimg.cn/27/14/28530936-1_l_46.jpg",
                //             store_name: "地图上的全景世界史",
                //             price: "￥210.0"
                //         }, {
                //             id: 112,
                //             image: "http://img3m8.ddimg.cn/97/30/28991158-1_l_15.jpg",
                //             store_name: "国际安徒生奖曹文轩拼音精选集（共八册，含小河弯弯，红葫芦，愤怒的哇哇，月光下的秘密，哑牛，狂奔的鸭群，八哥，有个丫头叫草环）",
                //             price: "￥50.0"
                //         }
                //     ]
                // }
            ],
            bookIconCategory: []
        }
    },
    computed: {
        swiper: function () {
            return this.$refs.mySwiper.swiper
        }
    },
    mounted: function () {
        this.getAllData();
    },
    deactivated: function () {
        // console.log("删除"); 防止页面缓存 从其他页面跳转过来之后
        // this.domBook.removeEventListener("scroll", this.getData);
    },
    activated: function () {
        this.domBook.scrollTo(0, this.leaveScroll);
    },
    beforeRouteLeave: function (to, from, next) {
        this.leaveScroll = this.scrollbar;
        next();
    },
    methods: {
        goSwiperUrl: function (index) {
            // let data = this.swiperData[index];
            // this.$router.push({
            //     path: "/goods_list",
            //     query: { id: data.id, title: data.title, type: 2}
            // });
        },
        getData: function (e) {
            const distance = Math.ceil((e.target.scrollTop / (e.target.scrollHeight - this.domBook.clientHeight)) * 100);
            // console.log(e.target.scrollTop,"=e.target.scrollTop", distance + '%' + "=占比");

            this.scrollbar = e.target.scrollTop;

            if (e.target.scrollTop > 750) {
                this.fixedNav = true;
            } else {
                this.fixedNav = false;
            }

            if (e.target.scrollTop > 150) {
                this.fixedSearch = true;
            } else {
                this.fixedSearch = false;
            }

            if (!this.delay && this.page !== 1 && distance > 85) {
                // console.log("触发调用",this.page)
                !this.loading && this.getIndexShopList();
            }
        },
        getAllData: function () {
            getBookHomeData().then((res) => {
                // console.log(res,"res")
                //获取banner图片数据
                let swiperList = [];
                res.data.banner.forEach((res) => {
                    swiperList.push({
                        pic: res.pic,
                        wap_url: res.wap_url,
                        id: res.id,
                        title: res.name
                    });
                })
                this.swiperData = swiperList;

                //图标
                this.bookIconCategory = res && res.data && res.data.info && res.data.info.firstCateList;


                //最受欢迎/新书上架 数据
                let list = [];
                res.data.info.indexCate && res.data.info.indexCate.forEach((res) => {
                    let _list = [];
                    res.product && res.product.forEach((val) => {
                        _list.push({
                            id: val.id,
                            image: val.image,
                            store_name: val.store_name,
                            price: "￥" + val.price,
                            author: val.author
                        });
                    })
                    list.push({
                        category: res.cate_name,
                        id: res.id,
                        list: _list
                    })
                });
                this.bookList = list;

                //获取分类导航数据
                this.shopNavList = res.data.info.fastList;
                //当前的图书类型
                this.shopType = res.data.info.fastList[this.currentShopNav].id;
            }).then(() => {
                this.delayGetData();
            })

            //监听滚动条
            const domBook = this.$refs.books;
            this.domBook = domBook;
            domBook.addEventListener("scroll", debounceFn(this.getData, 200), false);

        },
        getIndexShopList: async function () {
            if (this.loading || this.loaded) return;
            let { page, limit, shopType } = this;
            this.loading = true;
            await getProducts({ page, limit, cid: shopType, type: 2 }).then((res) => {
                if (res.data.length !== 0) {
                    this.shopDataList = this.shopDataList.concat(res.data);
                    this.page++;
                }
                this.loaded = res.data.length < this.limit;
                this.loading = false;
            }).catch((err) => {
                console.log(err);
            });
        },
        delayGetData: function () {
            if (this.delay) {
                this.getIndexShopList();
                this.delay = false;
            }
        },
        gotoType: function (id, name) {
            this.$router.push({
                path: '/goods_list',
                query: { id: id, title: name, type: 2, Switch: true }
            });
        },
        //切换分类导航
        changeCurrentShopNav: function (index, item) {
            if (index === this.currentShopNav) return;
            this.changeType(index, item.id);
            this.swiper.slideTo(index, 300);
        },
        changeType: function (index, id) {
            this.currentShopNav = index;
            this.shopDataList = [];
            this.page = 1;
            this.loaded = false;
            this.loading = false;
            if (id) {
                this.shopType = id;
            } else {
                this.shopNavList.forEach((item, ind) => {
                    if (index === ind) {
                        this.shopType = item.id;
                    }
                });
            }

            //导航条移动到中间
            const bnb = this.$refs.bookNavBar;
            const bn = this.$refs[`bookNav${index}`][0];
            const center = bn.offsetLeft - (bnb.clientWidth / 2) + (bn.offsetWidth / 2);
            this.$refs.bookNavBar.scrollTo(center, 0);

            //请求数据
            this.getIndexShopList();
            this.domBook.scrollTo(0, 1000);
        }
    }
}
</script>

<style scoped>
/* wrapper */
.book-wrapper {
    padding-bottom: 1rem;
}

/* 背景 */
.page-background {
    top: 0;
    left: 0;
    z-index: -10;
    width: 100%;
    height: 3rem;
}

.page-background .top {
    height: 2rem;
    background: linear-gradient(45deg, #00ffff 0%, #00caff 100%);
}

.page-background .bottom {
    height: 1rem;
    background: linear-gradient(150deg, #00ffff 0%, #00caff 100%);
    border-radius: 0 0 50% 50%;
}

/* 搜索 */
.header {
    height: 1.2rem;
}

.search {
    width: 100%;
    height: .8rem;
    background-color: #f7f7f7;
    border-radius: 0.2rem;
    padding: 0 0.28rem;
    font-size: 0.32rem;
    color: #878787;
}

.fixed-search {
    top: 0;
    z-index: 99;
    background: #fff;
}

.marginTop {
    margin-top: 1.2rem;
}

.search-icon-img {
    display: inline-block;
    width: 0.34rem;
    height: 0.34rem;
    margin-right: 0.3rem;
    background: url("../../assets/images/book-search-icon.png") no-repeat center;
    background-size: cover;
}

/* swiper */
.swiper-box {}

/* 热门/新书 */
.book-model-title {
    font-size: 0.38rem;
    color: #050505;
    font-weight: 550;
}

/* 图书导航 */
.paginationshop {
    height: .8rem;
    font-size: .3rem;
}

.paginationslot {
    display: inline-block;
    margin-right: .4rem;
    line-height: .8rem;
    font-weight: 600;
    font-size: .32rem;
}

.paginationshop .activeNav {
    color: #fc4141;
    font-size: .34rem;
}

.fixed-paginationshop {
    top: 1.2rem;
    left: 0;
    z-index: 100;
}

/* swiper */
.sort-shop-swiper {
    min-height: 13rem;
    /*一屏高*/
}

.top-margin {
    margin-top: .8rem;
}

.over-tip {
    line-height: 1rem;
    color: #868686;
}

/* 返回 */
.back-index {
    width: .8rem;
    height: .8rem;
    bottom: 1.5rem;
    right: .2rem;
    overflow: hidden;
    background: #fc4141;
    border-radius: 50%;
    text-align: center;
    line-height: .8rem;
    z-index: 99;
}

.back-index i {
    color: #fff;
    font-size: .4rem;
}

/* 原版-css */
.color-text {
    color: #868686;
}

.book-list-wrap {
    margin-bottom: .1rem;
    padding-left: .3rem;
}

/* end */
.nav {
    padding-top: .26rem;
}

.nav .item {
    width: 25%;
    text-align: center;
    font-size: .26rem;
    margin-bottom: .35rem;
}

.nav .item .pictrue {
    width: 1.2rem;
    height: 1.2rem;
    margin: 0 auto 0 auto;
}

.nav .item .pictrue img {
    width: 100%;
    height: 100%;
}

.newBoolshelf {
    width: 93%;
}

.newBook_title {
    display: flex;
    justify-content: space-between;
    width: 93%;
    height: 1rem;
    background: url("../../assets/images/newBookShif.png") no-repeat;
    background-size: 100% 100%;
    margin-left: 0.3rem;
}

.newBook_title .title_text {
    padding: 0.25rem 0.2rem;
    color: white;
    font-size: 0.35rem;
}

.newBook_title .title_more {
    padding: 0.3rem 0.2rem;
    color: white;
}

.newBook_content {
    width: 90%;
    height: 2rem;
    margin-left: 0.4rem;
    margin-top: 0.1rem;
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 0.2rem;
}

.content_text {
    margin-left: 0.1rem;
    width: 2rem;
}

.newBook_content .content {
    display: flex;
}

.content_name {
    font-size: 0.25rem;
    color: #9f9f9f;
    margin-top: 0.09rem;
}

.content_money {
    display: flex;
    justify-content: space-between;
    width: 2rem;
    margin-top: 0.1rem;
}

.money_plus {
    width: 0.3rem;
    height: 0.3rem;
    border-radius: 50%;
    background: #fc4141;
    color: white;
    font-size: 0.4rem;
    text-align: center;
    line-height: 0.32rem;
}

.money_number {
    color: #fc4141;
}
</style>